import React from 'react'
import './styles.css'

export default props => (
    <div className="columnIcon" >
        <p>
        <span className="" style={{marginLeft:20}}><b>{props.label}</b></span></p> 
      <hr/>
    </div>
)